class ErrorEmitter {
  install() {
    try {
      if (process.env.NODE_ENV === 'production') {
        console.log('%c请不要在控制台操作，以免丢失数据', 'font-size:100px;color:#fff;text-shadow:0 1px 0#ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);');﻿
      }
    } catch (e) {
    }

    window.addEventListener('error', (msg, url, row, col, error) => {
      let newMsg = msg;

      if (error && error.stack) {
        newMsg = ErrorEmitter.processStackMsg(error);
      }

      if (ErrorEmitter.isOBJByType(newMsg, "Event")) {
        newMsg += newMsg.type ?
          ("--" + newMsg.type + "--" + (newMsg.target ?
            (newMsg.target.tagName + "::" + newMsg.target.src) : "")) : "";
      }

      newMsg = (newMsg + "" || "").substr(0, 500);

      if (newMsg.toLowerCase().indexOf('script error') > -1) {
        console.error('Script Error: See Browser Console for Detail')
      } else {
        console.error(newMsg)
      }

      return true;
    }, true);

    window.addEventListener("unhandledrejection", e => {
      e.preventDefault();
      console.log(e.reason);
      return true;
    });
  }

  report({source, ...args}) {
    console.log({
      source,
      args
    });
  }

  static isOBJByType(o, type) {
    return Object.prototype.toString.call(o) === "[object " + (type || "Object") + "]"
  }

  static processStackMsg(error) {
    let stack = error.stack
      .replace(/\n/gi, "")
      .split(/\bat\b/)
      .slice(0, 9)
      .join("@")
      .replace(/\?[^:]+/gi, "");
    const msg = error.toString();
    if (stack.indexOf(msg) < 0) {
      stack = msg + "@" + stack;
    }
    return stack;
  }
}

const error_emitter = new ErrorEmitter();
export default error_emitter;



// WEBPACK FOOTER //
// ./src/utils/error-emitter.js